var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grey lighten-2 mb-2 mt-2 mx-2",staticStyle:{"height":"1px","width":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }